import React from "react";
import PageHero from "./PageHero";
import img13 from "../../media/images/garary/g2.jpg";
import img6 from "../../media/images/garary/g6.jpg";
import img4 from "../../media/images/garary/g4.jpg";
import img3 from "../../media/images/garary/g3.jpg";


import { FaPrayingHands, FaLeaf, FaBed } from "react-icons/fa";

function Retreats() {
  const retreats = [
    {
      title: "Weekend Retreat",
      duration: "2 Days",
      desc: "A short escape to refresh your mind and spirit.",
      image: img3
    },
    {
      title: "Spiritual Growth Retreat",
      duration: "5 Days",
      desc: "Deepen your faith and reconnect spiritually.",
      image: img6
    },
    {
      title: "Personal Reflection Retreat",
      duration: "3 Days",
      desc: "Quiet time for reflection and inner peace.",
      image: img4
    },
  ];

  return (
    <>
      {/* HERO */}
      <PageHero
        title="Retreats"
        subtitle="Experience spiritual growth and peace at our retreat centers"
        image={img13}
      />

      {/* INTRO */}
      <div className="container py-5 text-center">
        <h2 data-aos="fade-up">Find Your Peace</h2>
        <p className="mt-3" data-aos="fade-up">
          Our retreats are designed to help you disconnect from the noise of
          daily life and reconnect with your inner self and faith.
        </p>
      </div>

      {/* RETREAT CARDS */}
      <div className="container pb-5">
        <div className="row">
          {retreats.map((retreat, index) => (
            <div
              className="col-md-4 mb-4"
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div className="card shadow h-100">
                <img
                  src={retreat.image}
                  className="card-img-top"
                  alt="Retreat"
                />
                <div className="card-body">
                  <h5 className="card-title">{retreat.title}</h5>
                  <p className="text-success fw-bold">
                    Duration: {retreat.duration}
                  </p>
                  <p className="card-text">{retreat.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* PROGRAM FEATURES */}
      <div className="bg-light py-5">
  <div className="container text-center">
    <h2 className="mb-5" data-aos="fade-up">
      What to Expect
    </h2>

    <div className="row">
      
      {/* Guided Prayers */}
      <div className="col-md-4 mb-4" data-aos="fade-up">
        <div className="p-4 bg-white shadow rounded h-100">
          <FaPrayingHands size={40} className="text-success mb-3" />
          <h5>Guided Prayers</h5>
          <p>Daily sessions to strengthen your spiritual journey.</p>
        </div>
      </div>

      {/* Quiet Environment */}
      <div className="col-md-4 mb-4" data-aos="fade-up" data-aos-delay="100">
        <div className="p-4 bg-white shadow rounded h-100">
          <FaLeaf size={40} className="text-success mb-3" />
          <h5>Quiet Environment</h5>
          <p>Peaceful surroundings for reflection and meditation.</p>
        </div>
      </div>

      {/* Comfortable Stay */}
      <div className="col-md-4 mb-4" data-aos="fade-up" data-aos-delay="200">
        <div className="p-4 bg-white shadow rounded h-100">
          <FaBed size={40} className="text-success mb-3" />
          <h5>Comfortable Stay</h5>
          <p>Relax in our well-furnished and serene rooms.</p>
        </div>
      </div>

    </div>
  </div>
</div>

      {/* CTA SECTION */}
      <div
        className="text-white text-center py-5"
        style={{
          backgroundImage: `url(${img13})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div style={{ background: "rgba(0,0,0,0.6)", padding: "40px" }}>
          <h2 data-aos="fade-up">Ready for Your Retreat?</h2>
          <p data-aos="fade-up" className="mt-2">
            Book your retreat today and experience peace like never before.
          </p>
          <button className="btn btn-success mt-3" data-aos="fade-up">
            Book Now
          </button>
        </div>
      </div>
    </>
  );
}

export default Retreats;